import { jsxs as t, jsx as o } from "react/jsx-runtime";
const i = ({ width: e = 18, height: r = 18 }) => /* @__PURE__ */ t(
  "svg",
  {
    width: e,
    height: r,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "success-icon",
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16Z",
          fill: "var(--color-positiveFeedback)",
          stroke: "var(--color-positiveFeedback)",
          strokeWidth: 1.2,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "m5 9 2.667 2.667L13 6.334",
          stroke: "var(--color-grayScale-white)",
          strokeWidth: 1.2,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  i as SuccessIcon
};
